import { create } from "zustand";
import React from "react";

interface PremiumModalStore {
    element: React.ReactElement | null;
    open: (element: React.ReactElement) => void;
    close: () => void;
}

const usePremiumModalStore = create<PremiumModalStore>()((set) => ({
    element: null,
    open: (element) => set({ element }),
    close: () => set({ element: null })
}));

export default usePremiumModalStore;
